<h2 mat-dialog-title>{{ dialogTitle }}</h2>

<mat-dialog-content>
  <form [formGroup]="responderInfoForm" autocomplete="off">
    <div class="request-details">
      <mat-grid-list cols="2" rowHeight="66.5px" gutterSize="8px">
        <mat-grid-tile colspan="1">
          <mat-form-field>
            <input matInput formControlName="firstName" placeholder="First Name"required>
            <mat-error *ngIf="responderInfoForm.get('firstName').invalid && responderInfoForm.get('firstName').touched">
              First Name is required.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="1">
          <mat-form-field>
            <input matInput formControlName="lastName" placeholder="Last Name"required>
            <mat-error *ngIf="responderInfoForm.get('lastName').invalid && responderInfoForm.get('lastName').touched">
              Last Name is required.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <input matInput formControlName="email" placeholder="Email">
            <mat-error *ngIf="responderInfoForm.get('email').invalid && responderInfoForm.get('email').touched">
              Email is incorrect.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile colspan="2">
          <mat-form-field>
            <input matInput formControlName="msisdn" placeholder="Mobile Number" required>
            <mat-error *ngIf="responderInfoForm.get('msisdn').invalid && responderInfoForm.get('msisdn').touched">
              Mobile Number is required.
            </mat-error>
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </form>
  <p *ngIf="(!this.data.responder)">The Responder will be added to the default user group for <b>{{this.data.client.name}}.</b></p><br>
  <p *ngIf="(!this.data.responder)">The Responder will also be added to the default Armed Response Service for <b>{{this.data.client.name}}.</b></p><br>
</mat-dialog-content>

<mat-dialog-actions class="right-aligned-actions">
  
  <button mat-raised-button (click)="onCancel()" class="btn">Cancel</button>
  <button *ngIf="(this.data.responder)" mat-raised-button (click)="onSubmit()" class="btn btn-primary">Save Changes</button>
  <button *ngIf="(!this.data.responder)" mat-raised-button (click)="onSubmit()" class="btn btn-primary">Add Responder</button>
</mat-dialog-actions>